/**
 * @generated SignedSource<<2ebc6e40af3a51a88ed97d1d9f23e23d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTaskCollectionUpdateInput = {
  setTasks?: ReadonlyArray<CreateWidgetTaskCollectionInputTask> | null;
  setTitle?: string | null;
};
export type CreateWidgetTaskCollectionInputTask = {
  sectionId: string;
  taskId: string;
};
export type WSTaskCollectionMutation$variables = {
  storecastId: string;
  update: WidgetTaskCollectionUpdateInput;
  widgetId: string;
};
export type WSTaskCollectionMutation$data = {
  readonly dashboard: {
    readonly updateWidgetTaskCollection: {
      readonly id: string;
    };
  };
};
export type WSTaskCollectionMutation = {
  response: WSTaskCollectionMutation$data;
  variables: WSTaskCollectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "widgetId"
          },
          {
            "kind": "Variable",
            "name": "update",
            "variableName": "update"
          }
        ],
        "concreteType": "WidgetTaskCollection",
        "kind": "LinkedField",
        "name": "updateWidgetTaskCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTaskCollectionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSTaskCollectionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "316f7c7d42acc4bc8a5a872fe96e512a",
    "id": null,
    "metadata": {},
    "name": "WSTaskCollectionMutation",
    "operationKind": "mutation",
    "text": "mutation WSTaskCollectionMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $update: WidgetTaskCollectionUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetTaskCollection(id: $widgetId, update: $update) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b622ff9e6e0454c7b7a363b23c3539b0";

export default node;
